import { BenefitsSection } from '@/components/home/BenefitsSection';
import { FormulasSection } from '@/components/home/FormulasSection';
import { HeroSection } from '@/components/home/HeroSection';
import { HomeHeader } from '@/components/home/HomeHeader';
import { PartnersSection } from '@/components/home/PartnersSection';
import { PersonalizationSection } from '@/components/home/PersonalizationSection';
import { StartingStepsSection } from '@/components/home/StartingStepsSection';
import { SupplementsSection } from '@/components/home/SupplementsSection';
import { TestimonialsSection } from '@/components/home/TestimonialsSection';
import { TrustSection } from '@/components/home/TrustSection';
import { Footer } from '@/components/layout/Footer';

export function HomePage() {
  return (
    <div>
      <div className="flex min-h-screen flex-col">
        <HomeHeader />

        <main>
          <HeroSection />

          <SupplementsSection />

          <StartingStepsSection />

          <TrustSection />

          <BenefitsSection />

          <TestimonialsSection />

          <PersonalizationSection />

          <FormulasSection />

          <PartnersSection />
        </main>
      </div>

      <Footer />
    </div>
  );
}
